/** Plain-text preview from a stored message. Invoice history rows do not store a body. */
export function emailBodyPreview(text: string | null | undefined, html: string | null | undefined): string | null {
  const plain = text?.trim() || html?.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim() || '';
  if (!plain) return null;
  return plain.length > 280 ? `${plain.slice(0, 280)}…` : plain;
}
